import { type RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
    {
        path: '/users/:id/update',
        name: 'users.update',
        component: () => import('@/views/User/Update.vue'),
        props: true,
    },
];

export default routes;
